var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.COLORS.SECONDARY},on:{"click":function($event){return _vm.actionCallback()}}},[_vm._v(" "+_vm._s(_vm.$t(("buttons." + _vm.btnText)))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }